import { makeModeFillImage } from '@Utils/make-mode-fill';
import { a, useSpring } from '@react-spring/three';
import { THREE } from 'expo-three';
import { useEffect, useState } from 'react';

type Props = {
  imageUrl: string;
  planeSize: { height: number; width: number };
  showInstantly?: boolean;
  transparencyColor?: string;
  onImageLoad?: () => void;
  opacity?: number;
};

export function ImageMaterialRectangle({
  imageUrl,
  showInstantly,
  planeSize,
  transparencyColor,
  onImageLoad,
  opacity = 1,
}: Props) {
  const [loaded, setLoaded] = useState(false);
  const [colorMap, setColorMap] = useState(() => new THREE.Texture());

  useEffect(() => {
    if (!imageUrl || !planeSize) {
      return undefined;
    }

    const texture = new THREE.TextureLoader().load(imageUrl, (tex) => {
      makeModeFillImage({ planeSize, tex });
      setColorMap(tex);
      setLoaded(true);
    });

    setColorMap(texture);
  }, [imageUrl, planeSize]);

  useEffect(() => {
    if (loaded) {
      onImageLoad?.();
    }
  }, [loaded]);

  const getOpacity = () => {
    const internal = (() => {
      if (showInstantly) {
        return 1;
      }

      return loaded ? 1 : 0;
    })();

    return Math.min(internal, opacity);
  };

  const { opacityAnim } = useSpring({
    from: { opacityAnim: 0 },
    to: { opacityAnim: getOpacity() },
    config: { duration: 500 },
  });

  return (
    // eslint-disable-next-line @typescript-eslint/prefer-ts-expect-error
    // @ts-ignore
    <a.meshBasicMaterial
      map={colorMap}
      transparent
      opacity={opacityAnim}
      color={transparencyColor}
    />
  );
}
